import React from 'react'
import NotAvailableTasksIllustration from '../illustrations/NotAvailableTasksIllustration'
import {useTranslation} from "react-i18next";


type Data = {
  message?: string
}


export default function NotAvailableTaskCardWrap({
  message: messageProp = 'No available tasks',
  ...props
}: Data) {

  const { t } = useTranslation()

  return (
    <div className="task-card-wrap not-available-tasks-card">
      <NotAvailableTasksIllustration/>
      <div className='send-tech-block'>
        <p>
          {t(messageProp as string)}
        </p>
      </div>
    </div>)
}
